<template>
    <results-page></results-page>
</template>

<script>
    import ResultsPage from './ResultsPage.vue'

    export default {
        components: {
            ResultsPage,
        },
    }
</script>
